import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { Center, VStack, Wrap } from "../../../../../styled-system/jsx";
import { useFormily } from "../../../../hooks/useFormily";
import { ArrayField, Field, FormProvider } from "@formily/react";
import { CurrencyInput, OffsetInput } from "../../../../components/fields/formily/NumberInput";
import { Button } from "../../../../components/core/basic/Button";
import { Select } from "../../../../components/fields/formily/Select";
import { Modal } from "../../../../components/core/basic/RACModal";
import { css } from "../../../../../styled-system/css";
import { TextField } from "../../../../components/fields/formily/TextField";
import { FaPlus } from "react-icons/fa6";

interface FormValues {
  minPrice: number;
  maxPrice: number;
  additionalConstraints: {
    targetType: "hero" | "external";
    target: string;
    constraintOn: "min" | "max";
    adjust: {
      offset: number;
      type: "percentage" | "amount";
    };
  }[];
}

interface Props {
  initialValues: FormValues;
  onSubmit: (values: FormValues) => void;
}

export const ConstraintsManagementModal = NiceModal.create(({ initialValues, onSubmit }: Props) => {
  const modal = useModal();
  const form = useFormily({
    initialValues,
  });

  return (
    <Modal
      isOpen={modal.visible}
      isDismissable
      onOpenChange={(isOpen) => (isOpen ? void 0 : modal.remove())}
      title={"Manage constraints"}
    >
      <FormProvider form={form}>
        <VStack flex="auto" paddingX={"large"}>
          <Wrap>
            <Field name="minPrice" title={"Min Price"} component={[CurrencyInput]} />
            <Field name="maxPrice" title={"Max Price"} component={[CurrencyInput]} />
          </Wrap>
          <ArrayField name="additionalConstraints">
            {(field) => {
              return (
                <>
                  {field.value.map((constraint, index) => (
                    <Wrap key={index} alignItems={"end"} borderTop={"1px solid {colors.lightgrey}"}>
                      <Field
                        name={`${index}.targetType`}
                        title="Target"
                        component={[Select]}
                        dataSource={[
                          { label: "Hero product", value: "hero" },
                          { label: "External product", value: "external" },
                        ]}
                        reactions={(field) => {
                          field.query(".target").take((targetField) => {
                            targetField.hidden = field.value !== "external";
                          });
                        }}
                      />
                      <Field name={`${index}.target`} title="Target ASIN" component={[TextField]} />
                      <Field
                        name={`${index}.constraintOn`}
                        title="Adjust"
                        component={[Select]}
                        dataSource={[
                          { label: "Min", value: "min" },
                          { label: "Max", value: "max" },
                        ]}
                      />
                      <Field name={`${index}.adjust`} component={[OffsetInput]} />

                      <Button
                        onPress={() => {
                          void field.remove(index);
                        }}
                        height="37px"
                      >
                        Remove
                      </Button>
                    </Wrap>
                  ))}
                  <Center>
                    <Button
                      onPress={() =>
                        void field.push({
                          targetType: "hero",
                          target: "",
                          constraintOn: "min",
                          adjust: {
                            offset: 0,
                            type: "percentage",
                          },
                        })
                      }
                    >
                      <FaPlus />
                      Add
                    </Button>
                  </Center>
                </>
              );
            }}
          </ArrayField>
          <div className={css({ flex: "1", borderBottom: "1px solid {colors.lightgrey}", width: "100%" })}></div>
          <Button
            onPress={async () => {
              await form.submit(onSubmit);
              modal.remove();
            }}
          >
            Submit
          </Button>
        </VStack>
      </FormProvider>
    </Modal>
  );
});
